let currentType = 'all';
let currentLanguage = 'all';
let visibleLimit = 6;

let desktopTypeFilters, languageFilters, dropdownToggle, dropdownMenu, dropdownOptions, loadMoreBtn;

function isMobileViewport() {
  return window.matchMedia('(max-width: 768px)').matches;
}

function initFilterState() {
  const activeTypeFilter = document.querySelector('.press-media-type-filtering-container.desktop .press-media-type-filtering-item.active');
  if (activeTypeFilter) {
    currentType = activeTypeFilter.dataset.type || 'all';
    syncMobileDropdown(currentType);
  } else {
    currentType = 'all';
  }

  const activeLanguageFilter = document.querySelector('.press-media-language-filtering-item.active');
  if (activeLanguageFilter) {
    currentLanguage = activeLanguageFilter.dataset.language || 'all';
  } else {
    currentLanguage = 'all';
  }
}

function initPressMedia() {
  desktopTypeFilters = document.querySelectorAll('.press-media-type-filtering-container.desktop .press-media-type-filtering-item');
  languageFilters = document.querySelectorAll('.press-media-language-filtering-item');
  dropdownToggle = document.querySelector('.press-media-custom-dropdown-toggle');
  dropdownMenu = document.querySelector('.press-media-custom-dropdown-menu');
  dropdownOptions = document.querySelectorAll('.press-media-custom-dropdown-option');
  loadMoreBtn = document.querySelector('.press-media-load-more');

  setupDropdown();
  setupDesktopFilters();
  setupLanguageFilters();
  setupLoadMore();
  initFilterState();

  applyFilters();
}

function setupDropdown() {
  if (!dropdownToggle || !dropdownMenu) return;

  // Toggle dropdown
  dropdownToggle.addEventListener('click', function (e) {
    e.preventDefault();
    const isOpen = dropdownMenu.classList.contains('open');
    dropdownMenu.classList.toggle('open');
    dropdownToggle.setAttribute('aria-expanded', !isOpen);
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!dropdownToggle.contains(e.target) && !dropdownMenu.contains(e.target)) {
      dropdownMenu.classList.remove('open');
      dropdownToggle.setAttribute('aria-expanded', false);
    }
  });

  // Handle option selection
  dropdownOptions.forEach((option) => {
    option.addEventListener('click', function (e) {
      e.preventDefault();
      const value = this.dataset.value;
      const label = this.dataset.label;
      const icon = this.dataset.icon;

      // Update current display
      const currentDisplay = dropdownToggle.querySelector('.press-media-custom-dropdown-current');
      if (currentDisplay) {
        currentDisplay.innerHTML = `
            <img src="${icon}" class="press-media-type-icon" alt="" loading="lazy">
            <span>${label}</span>
          `;
      }

      // Update selected state
      dropdownOptions.forEach((opt) => {
        opt.setAttribute('aria-selected', opt === this);
      });

      // Close dropdown
      dropdownMenu.classList.remove('open');
      dropdownToggle.setAttribute('aria-expanded', false);

      // Sync desktop type filters
      syncDesktopTypeFilters(value);

      // Trigger filtering
      currentType = value;
      applyFilters();
    });
  });
}

function syncDesktopTypeFilters(value) {
  if (desktopTypeFilters) {
    desktopTypeFilters.forEach((f) => {
      if (f.dataset.type === value) {
        f.classList.add('active');
      } else {
        f.classList.remove('active');
      }
    });
  }
}

function syncMobileDropdown(value) {
  if (dropdownToggle && dropdownOptions) {
    const targetOption = Array.from(dropdownOptions).find((opt) => opt.dataset.value === value);
    if (targetOption) {
      const label = targetOption.dataset.label;
      const icon = targetOption.dataset.icon;
      const currentDisplay = dropdownToggle.querySelector('.press-media-custom-dropdown-current');
      if (currentDisplay) {
        currentDisplay.innerHTML = `
            <img src="${icon}" class="press-media-type-icon" alt="" loading="lazy">
            <span>${label}</span>
          `;
      }
      dropdownOptions.forEach((opt) => {
        opt.setAttribute('aria-selected', opt === targetOption);
      });
    }
  }
}

function setupDesktopFilters() {
  if (!desktopTypeFilters) return;
  desktopTypeFilters.forEach((filter) => {
    filter.addEventListener('click', function () {
      desktopTypeFilters.forEach((f) => f.classList.remove('active'));
      this.classList.add('active');
      currentType = this.dataset.type;

      // Sync mobile dropdown state
      syncMobileDropdown(currentType);

      applyFilters();
    });
  });
}

function setupLanguageFilters() {
  if (!languageFilters) return;
  languageFilters.forEach((filter) => {
    filter.addEventListener('click', function () {
      languageFilters.forEach((f) => f.classList.remove('active'));
      this.classList.add('active');
      currentLanguage = this.dataset.language;
      applyFilters();
    });
  });
}

function setupLoadMore() {
  if (!loadMoreBtn) return;
  loadMoreBtn.addEventListener('click', function () {
    const isMobile = isMobileViewport();
    const increment = isMobile ? 4 : 6;
    visibleLimit += increment;
    renderVisibleItems();
  });
}

function sortMediaItems() {
  const grid = document.querySelector('.press-media-items-grid');
  if (!grid) return;
  const items = Array.from(grid.querySelectorAll('.press-media-item-container'));

  items.sort((a, b) => {
    const weightA = parseFloat(a.getAttribute('data-sorting-weight')) || 0;
    const weightB = parseFloat(b.getAttribute('data-sorting-weight')) || 0;
    return weightB - weightA;
  });

  items.forEach((item) => {
    grid.appendChild(item);
  });
}

function renderVisibleItems() {
  const sortedItems = document.querySelectorAll('.press-media-item-container');
  const matchingItems = [];

  sortedItems.forEach((item) => {
    const itemType = item.dataset.type;
    const itemLanguage = item.dataset.language;

    const typeMatch = currentType === 'all' || itemType === currentType;
    const languageMatch = currentLanguage === 'all' || itemLanguage === currentLanguage;
    // Items that utm-campaigns.js left hidden for the active campaign (they keep
    // data-utm-active, which CSS hides) must not take up a slot in the visible
    // limit either.
    const utmMatch = !item.hasAttribute('data-utm-active');

    if (typeMatch && languageMatch && utmMatch) {
      matchingItems.push(item);
    } else {
      item.style.display = 'none';
    }
  });

  matchingItems.forEach((item, index) => {
    if (index < visibleLimit) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });

  if (loadMoreBtn) {
    if (matchingItems.length > visibleLimit) {
      loadMoreBtn.style.display = 'flex';
    } else {
      loadMoreBtn.style.display = 'none';
    }
  }
}

function applyFilters() {
  const isMobile = isMobileViewport();
  visibleLimit = isMobile ? 4 : 6;

  // No sorting here on purpose: the grid order is set once (standard sorting
  // first, campaign reordering on top of it) and filtering only toggles
  // visibility, so re-sorting would drop the campaign order.
  renderVisibleItems();
}

// Ordering happens in two passes so that both sortings can be applied:
//
// 1. The standard data-sorting-weight sorting runs first, as early as possible.
//    This file is deferred and included by the section, so it executes before
//    utm-campaigns.js (deferred too, but further down in theme.liquid) and its
//    DOMContentLoaded listener is registered first as well.
// 2. utm-campaigns.js then applies the data-utm-reorder positions on top of the
//    already sorted grid in its own DOMContentLoaded handler.
//
// Rendering is therefore queued as a separate task, after every
// DOMContentLoaded listener has run, so that pagination sees the final order.
function initOrdering() {
  sortMediaItems();
  setTimeout(initPressMedia, 0);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOrdering);
} else {
  initOrdering();
}
